import { render, staticRenderFns } from "./BookingTourGroup.vue?vue&type=template&id=3de44e3a&scoped=true&"
import script from "./BookingTourGroup.vue?vue&type=script&lang=js&"
export * from "./BookingTourGroup.vue?vue&type=script&lang=js&"
import style0 from "./BookingTourGroup.vue?vue&type=style&index=0&id=3de44e3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de44e3a",
  null
  
)

export default component.exports